import "./AIThreatDetection.module.css";
import Header from "@/reusable_sections/Header";
import Aithreatdetectionhero from "./sections/Aithreatdetectionhero";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function AIThreatDetectionPage() {
  return <div>
      <Header />
      <Aithreatdetectionhero />
      <Services />
      <Footer />
    </div>;
}